import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { SmartDevice, SmartDeviceSettingsResponse } from './model'

export interface State extends EntityState<SmartDevice> {
  isLoaded: boolean
  settings?: SmartDeviceSettingsResponse
  isSettingsLoaded: boolean
}

export function getDeviceUniqId(item: { connectedAccountId: string; deviceId: string }): string {
  return item.connectedAccountId + '_' + item.deviceId
}

export const adapter: EntityAdapter<SmartDevice> = createEntityAdapter<SmartDevice>({
  selectId: getDeviceUniqId,
  sortComparer: false,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isSettingsLoaded: false,
})
